/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCurrency,
    MelcoModelsCurrencyFromJSON,
    MelcoModelsCurrencyFromJSONTyped,
    MelcoModelsCurrencyToJSON,
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsCurrency
 */
export interface MelcoModelsGenericList1MelcoModelsCurrency {
    /**
     * 
     * @type {Array<MelcoModelsCurrency>}
     * @memberof MelcoModelsGenericList1MelcoModelsCurrency
     */
    list: Array<MelcoModelsCurrency>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsCurrency
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsCurrency
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsCurrencyFromJSON(json: any): MelcoModelsGenericList1MelcoModelsCurrency {
    return MelcoModelsGenericList1MelcoModelsCurrencyFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsCurrencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsCurrency {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsCurrencyFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsCurrencyToJSON(value?: MelcoModelsGenericList1MelcoModelsCurrency | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsCurrencyToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


